import { css, SerializedStyles } from '@emotion/core';

import { Theme, normalText } from 'features/Theme';
const styles = {
  headingContainer: (theme: Theme) => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
    text-align: center;
  `,
  normalText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)};
    text-align: center;
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  imageContainer: (theme: Theme) => css`
    margin: 0 auto;
    width: ${theme.mui.spacing(25)}px;
    height: ${theme.mui.spacing(40)}px;
    align-items: center;
    justify-content: center;
  `,

  mobileSuccessImage: () => css`
    width: 100%;
    display: block;
  `,
  containerStyles: () => css``,

  otpSection: (theme: Theme) => css`
    ${normalText(theme)}
    text-align: center;
    font-size: ${theme.mui.typography.h3.fontSize};
  `,
};

export default styles;
